function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { fontRegular } from '../../theme/fonts';
import { primary50, primary600, teal50, teal700, focusShadow } from '../../theme/colors';
export const VARIANT_MAP = {
  teal: {
    color: teal700,
    background: teal50
  },
  primary: {
    color: primary600,
    background: primary50
  }
};
export const Wrapper = styled.a`
  background: transparent;
  border: 0;
  padding: 0;
  color: ${({
  variant
}) => VARIANT_MAP[variant].color};
  font-family: ${fontRegular};
  font-size: inherit;
  text-decoration: underline;

  &:hover {
    background: ${({
  variant
}) => VARIANT_MAP[variant].background};
    cursor: pointer;
  }

  &:focus {
    box-shadow: 0 0 0 3px ${focusShadow};
    outline: none;
  }
`;
export const Link = ({
  children,
  external = false,
  variant = 'teal',
  as = 'a',
  onClick,
  href,
  ...props
}) => {
  const rel = external ? 'noreferrer noopener' : '';
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    href,
    as,
    onClick,
    rel: rel,
    variant: variant
  }, props), children);
};
export default Link;
//# sourceMappingURL=index.js.map